import * as React from 'react';

export interface FormErrorProps {
}

export default class FormError extends React.Component<FormErrorProps, any> {
  public render() {
    return (
      <div>
        {}
      </div>
    );
  }
}
